import { OrderEvent } from '@oolio-group/domain';
import { unionBy } from 'lodash';
import { sortEventsByTimeStamp } from '@oolio-group/order-helper';
import { isForeignLoneInitiate } from '../../utils/isForeignLoneInitiate';

export function nextEventsByOrderId(
  currentEvents: OrderEvent[],
  incomingEvents: OrderEvent[],
): OrderEvent[] {
  const currentOrderId = currentEvents[0]?.orderId;
  const incomingOrderId = incomingEvents[0]?.orderId;

  if (!incomingOrderId) return currentEvents;

  if (isForeignLoneInitiate(currentOrderId, incomingEvents)) {
    return currentEvents;
  }

  if (currentOrderId && incomingOrderId !== currentOrderId) {
    return incomingEvents;
  }

  // hlc-aware sort (not raw timestamp) so tie-breaking here agrees with
  // isPaymentAttemptSuperseded/isReopenStillActive's ordering.
  return sortEventsByTimeStamp(unionBy(currentEvents, incomingEvents, 'id'));
}
